"use client";

/**
 * ComponentRenderer
 * Renders individual landing page components based on their type
 */

import { LandingPageComponent } from "@/lib/database/landing-pages";
import NavbarComponent from "../components/navbar/NavbarComponent";
import HeroComponent from "../components/hero/HeroComponent";
import ScheduleComponent from "../components/schedule/ScheduleComponent";
import FAQComponent from "../components/faq/FAQComponent";
import VenueComponent from "../components/venue/VenueComponent";
import CarouselComponent from "../components/carousel/CarouselComponent";
import TextButtonComponent from "../components/text-button/TextButtonComponent";
import RichTextComponent from "../components/rich-text/RichTextComponent";
import ActivitiesComponent from "../components/activities/ActivitiesComponent";

interface ComponentRendererProps {
  component: LandingPageComponent;
  eventId: number;
  primaryColor?: string;
  landingPageId?: number;
  pageContext?: string; // "main" or subpage slug
}

export default function ComponentRenderer({
  component,
  eventId,
  primaryColor,
  landingPageId,
  pageContext = "main",
}: ComponentRendererProps) {
  switch (component.type) {
    case "navbar":
      return <NavbarComponent component={component} eventId={eventId} primaryColor={primaryColor} />;
    case "hero":
      return <HeroComponent component={component} eventId={eventId} primaryColor={primaryColor} />;
    case "schedule":
      return <ScheduleComponent component={component} eventId={eventId} primaryColor={primaryColor} />;
    case "faq":
      return <FAQComponent component={component} eventId={eventId} primaryColor={primaryColor} />;
    case "venue":
      return <VenueComponent component={component} eventId={eventId} primaryColor={primaryColor} />;
    case "carousel":
      return <CarouselComponent component={component} primaryColor={primaryColor} />;
    case "textButton":
      return <TextButtonComponent component={component} eventId={eventId} primaryColor={primaryColor || "#5261EB"} />;
    case "richText":
      return <RichTextComponent component={component} eventId={eventId} primaryColor={primaryColor || "#5261EB"} />;
    case "activities":
      return (
        <ActivitiesComponent
          component={component}
          primaryColor={primaryColor}
          landingPageId={landingPageId}
          pageContext={pageContext}
        />
      );
    default:
      return (
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-yellow-800 text-sm">Unknown component type: {component.type}</p>
          </div>
        </div>
      );
  }
}
